import { IDs } from '../../../helpers/IDs';

export class Data {
    public static fallback: any = {
        [IDs.ENT_MASCHINEN]: {
            maschinen_typ_tid: 'Anlage/Maschine'
        }
    };
    public static predefined: any = {
        /*[IDs.ENT_MASCHINEN]: {
            maschinen_typ_tid: 'Anlage/Maschine'
        }*/
    };
    public static selector: any = {
        [IDs.ENT_FAHRZEUGE]: {
            standort_tid: {
                filter: { energiedaten_erfassen_orig: 1 }
            }
        },
        [IDs.ENT_MASCHINEN]: {
            standort_tid: {
                filter: { energiedaten_erfassen_orig: 1 }
            }
        }
    };
    public static whitelist: any = {
        [IDs.ENT_MASCHINEN]: {
            maschinen_typ_tid: ['Anlage/Maschine', 'Beleuchtung', 'Heizung']
        }
    };
}
